import React from 'react';
import Banner from '../Banner';
import "./HomeScreen.css";
 import Navbar from '../Navbar';
import requests from '../Requests';
import Row from '../Row';

function HomeScreen() {
  return (
    <div className='homeScreen'>
    <Navbar/>
    <Banner/>
    {/* <Row
    title= "Latest Movies"
    fetchUrl= {requests.fetchLatest}
    /> */}
   
    <Row  title= "Top Rated"
    fetchUrl= {requests.fetchTopRated}/>

<Row  title= "Upcoming Movies"
    fetchUrl= {requests.fetchUpcoming}/>

<Row  title= "Popular Movies"
    fetchUrl= {requests.fetchPopular}/>

<Row  title= "Now Playing Movies"
    fetchUrl= {requests.fetchNowPlaying}/>
    
    
    
    </div>
  
  )
}

export default HomeScreen